module.exports = __webpack_public_path__ + "img/dashboardLeftIcon.03c18a08.svg";